import { Injectable } from '@angular/core';
import { PriceService } from './price.service'; // ton service actuel qui wrappe CoinGecko
import { firstValueFrom } from 'rxjs';
import { ethers } from 'ethers';

@Injectable({ providedIn: 'root' })
export class NativeTokenPriceService {
  private symbolByChainId: Record<number, string> = {
    1: 'ETH',
    42161: 'ETH',
    137: 'MATIC',
    56: 'BNB',
    10: 'ETH',
    43114: 'AVAX'
  };

  private cachedPrices: Record<number, number> = {};

  constructor(private price: PriceService) { }

  getSymbol(chainId: number): string {
    return this.symbolByChainId[chainId] ?? 'ETH';
  }





  async getOnChainUsd(
    chainId: number,
    provider: ethers.BrowserProvider | null
  ): Promise<number> {
    if (!provider) return 0;

    // Feeds Chainlink (Proxy) – prix natif/USD
    const feedByChain: Record<number, string> = {
      1: '0x5f4ec3df9cbd43714fe2740f5e3616155c5b8419', // ETH / USD (Ethereum)
      42161: '0x639Fe6ab55C921f74e7fac1ee960C0B6293ba612', // ETH / USD (Arbitrum)
      137: '0xab594600376ec9fd91f8e885dadf0ce036862de0', // MATIC / USD (Polygon)
      56: '0x0567F2323251f0Aab15c8dFb1967E4e8A7D42aeE', // BNB / USD (BSC)
      10: '0x13e3Ee699D1909E989722E753853AE30b17e08c5', // ETH / USD (Optimism)
      43114: '0x0A77230d17318075983913bC2145DB16C7366156', // AVAX / USD (Avalanche)
    };

    const feed = feedByChain[chainId];
    if (!feed) return 0;

    // ABI minimal Chainlink AggregatorV3
    const abi = [
      { "inputs": [], "name": "decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "stateMutability": "view", "type": "function" },
      {
        "inputs": [], "name": "latestRoundData", "outputs": [
          { "internalType": "uint80", "name": "roundId", "type": "uint80" },
          { "internalType": "int256", "name": "answer", "type": "int256" },
          { "internalType": "uint256", "name": "startedAt", "type": "uint256" },
          { "internalType": "uint256", "name": "updatedAt", "type": "uint256" },
          { "internalType": "uint80", "name": "answeredInRound", "type": "uint80" }
        ], "stateMutability": "view", "type": "function"
      }
    ];

    try {
      const agg = new ethers.Contract(feed, abi, await provider.getSigner());

      // Typescript se plaint des index signatures -> accès bracket []
      const dec: number = await agg['decimals']();
      const rd = await agg['latestRoundData']();

      // rd.answer est un BigInt (ou BigNumber) signed -> convertissons en number
      const answer: bigint = BigInt(rd.answer.toString());
      const scale: bigint = BigInt(10) ** BigInt(dec);

      // Conversion finale en number
      const usd = Number(answer) / Number(scale);

      return usd > 0 ? usd : 0;
    } catch (e) {
      console.warn('[Chainlink] getOnChainUsd a échoué -> 0', e);
      return 0;
    }
  }



  async getUsdPrice(chainId: number): Promise<number> {
    if (this.cachedPrices[chainId]) return this.cachedPrices[chainId];

    const symbol = this.getSymbol(chainId);
    try {
      const prices = await firstValueFrom(this.price.fetchPrices([symbol], 'usd'));
      const usd = prices[symbol] ?? 0;
      this.cachedPrices[chainId] = usd;
      return usd;
    } catch (err) {
      console.warn(`❌ Erreur CoinGecko (${symbol}/USD) :`, err);
      return 0;
    }
  }

  async getFiatConversionRate(targetCurrency: string): Promise<number> {
    console.log(`[🔄] getFiatConversionRate() appelé avec targetCurrency = ${targetCurrency}`);

    if (targetCurrency.toUpperCase() === 'USD') {
      console.log('[💵] targetCurrency est USD, retourne 1');
      return 1;
    }

    try {
      const vs = targetCurrency.toLowerCase();
      console.log(`[🌍] Récupération du prix de 1 USD en ${vs} via CoinGecko...`);

      const prices = await firstValueFrom(this.price.fetchPrices(['usd'], vs));

      console.log('[📦] Réponse de fetchPrices :', prices);

      const rate = prices['usd'];
      console.log(`[🔢] 1 USD = ${rate} ${vs}`);

      if (rate && rate !== 0) {
        return rate;
      } else {
        console.warn(`⚠️ Taux retourné nul ou invalide pour USD → ${targetCurrency}`);
        return 1;
      }
    } catch (err) {
      console.warn(`❌ Erreur conversion USD → ${targetCurrency} :`, err);
      return 1;
    }
  }





  // (optionnel)
  clearCache(): void {
    this.cachedPrices = {};
  }
}
